<template>
    <div>
		<div class="p-fluid p-mt-2 p-ml-4 p-mr-4">
			<div class="p-formgrid p-grid p-justify-start">
				<div class="p-field p-col-12 p-lg-3">
					<label for="provinceOptions">{{$t('province')}}</label>
					<Dropdown v-model="province_select" :options="provinceOptions" optionLabel="province_name" :filter="true" :placeholder="$t('placeholderSelectBox')" :showClear="true">
						<template #value="provinceOptions">
							<div v-if="provinceOptions.value">
								<div>{{provinceOptions.value.province_name}}</div>
							</div>
						</template>
						<template #option="provinceOptions">
							<div>{{provinceOptions.option.province_name}}</div>
						</template>
					</Dropdown>
				</div>
					
				<div class="p-field p-col-12 p-lg-3">
					<label for="amphurOptions">{{$t('amphur')}}</label>
					<Dropdown :disabled="isDisabledAmphur == 1" v-model="amphur_select" :options="amphurOptions" optionLabel="amphur_name" :filter="true" :placeholder="$t('placeholderSelectBox')" :showClear="true">
						<template #value="amphurOptions">
							<div v-if="amphurOptions.value">
								<div>{{amphurOptions.value.amphur_name}}</div>
							</div>
						</template>
						<template #option="amphurOptions">
							<div>{{amphurOptions.option.amphur_name}}</div>
						</template>
					</Dropdown>
				</div>

				<div class="p-field p-col-12 p-lg-3">
					<label for="tambonOptions">{{$t('tambon')}}</label>
					<Dropdown :disabled="isDisabledTambon == 1" v-model="tambon_select" :options="tambonOptions" optionLabel="tambon_name" :filter="true" :placeholder="$t('placeholderSelectBox')" :showClear="true">
						<template #value="tambonOptions">
							<div v-if="tambonOptions.value">
								<div>{{tambonOptions.value.tambon_name}}</div>
							</div>
						</template>
						<template #option="tambonOptions">
							<div>{{tambonOptions.option.tambon_name}}</div>
						</template>
					</Dropdown>
				</div>
				<div class="p-field p-col">
                  <div class="p-formgrid p-grid p-mt-3 p-jc-end">
					<div class="p-field  p-lg-3"><Button @click="searchResponseArea()" :label="$t('searchBtn')" class="p-button-info" /></div>
					<div class="p-field  p-lg-3"><Button @click="selectItem()" :label="$t('selectBtn')" class="p-button-success" /></div> 
                  </div>
                </div>
			</div>
		</div>
        <!-- Organize -->
		<small class="p-invalid" v-if="error_selectedResponseArea && !selectedResponseArea">{{$t('io_error_selectedResponseArea_validate')}}</small>
		<DataTable 
		:value="responseAreaTable" 
		:scrollable="true" scrollHeight="500px"
		:paginator="true" 
		:rows="10" 
				dataKey="tambon_id" 
				:rowHover="true" :filters="filters" ref="dt" :selection.sync="selectedResponseArea"
				paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
				:rowsPerPageOptions="[10,20,50]"
				currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}">
				<template #empty>{{$t('TableEmpty')}}</template>
				<Column selectionMode="multiple" 
				headerStyle="width: 3rem"
				>
			</Column>
				<Column field="province_name" :header="$t('province')" :sortable="true "
				headerStyle="width: 10rem">
					<template #body="dataTable" >
						{{dataTable.data.province_name}}
					</template>
				</Column>
				<Column field="amphur_name" :header="$t('amphur')" :sortable="true" headerStyle="width: 10rem">
					<template #body="dataTable" >
						{{dataTable.data.amphur_name}}
					</template>
				</Column>
				<Column field="tambon_name" :header="$t('tambon')" :sortable="true" headerStyle="width: 10rem">
					<template #body="dataTable" >
						{{dataTable.data.tambon_name}}
					</template>
				</Column>
		</DataTable>
    </div>
</template>

<script>
 
	export default {
		name: "response-area-table",
		props: ['parentmessage'],
		data(){
			return{
				isDisabledAmphur: 1,
				isDisabledTambon: 1,
				organize_name : '',
				provinceOptions : [],
				province_select : null,
				amphurOptions : [],
				amphur_select : null,
				tambonOptions : [],
				tambon_select : null,
				
				responseAreaTable : [],
				filters : {},
				selectedResponseArea: null,
				error_selectedResponseArea : false
			}
		},

		async created(){
			await this.axios.post(`${this.$url_service}/general/country`, {
				body: {
					topic: 'get-all-country',
				}
			}).then(response => (this.responseAreaTable = response.data.data))

			await this.axios.post(`${this.$url_service}/general/country`, {
				body: {
					topic: 'get-province',
				}
			}).then(response => {(this.provinceOptions = response.data.data),(this.provinceOptions.splice(0,0,{'province_id':'getall','province_name':this.$i18n.t('selectAll')}))})
		},
		mounted() {
			this.selectedResponseArea = this.parentmessage
		},

		methods: {
            async searchResponseArea(){
				var province, amphur, tambon;
				if(this.province_select == null){ province = 'getall' }else{ province = this.province_select.province_id }
				if(this.amphur_select == null){ amphur = 'getall' }else{ amphur = this.amphur_select.amphur_id }
				if(this.tambon_select == null){ tambon = 'getall' }else{ tambon = this.tambon_select.tambon_id }
			
				await this.axios.post(`${this.$url_service}/general/country`, {
					body: {
						topic: 'search-country',
						province: province,
						amphur: amphur,
						tambon: tambon
					}
				}).then(response => (this.responseAreaTable = response.data.data))
			},

			selectItem(){
				if(this.selectedResponseArea == null){
					this.error_selectedResponseArea = true
				}else{
					this.$emit("selectResponseArea", this.selectedResponseArea);
				}
			}
		},

		watch:{
			async province_select(val){
				this.amphur_select = null
				if(val != null){
					this.isDisabledAmphur = 0;
					await this.axios.post(`${this.$url_service}/general/country`, {
						body: {
							topic: 'get-amphur',
							province_id: val.province_id
						}
					}).then(response => {(this.amphurOptions = response.data.data),(this.amphurOptions.splice(0,0,{'amphur_id':'getall','amphur_name':this.$i18n.t('selectAll')}))})
				}else{
					this.isDisabledAmphur = 1;
					this.amphur_select = null
					this.tambon_select = null;
				}
			},

			async amphur_select(val){
				this.tambon_select = null;
				if(val != null){
					this.isDisabledTambon = 0;
					await this.axios.post(`${this.$url_service}/general/country`, {
						body: {
							topic: 'get-tambon',
							amphur_id: val.amphur_id
						}
					}).then(response => {(this.tambonOptions = response.data.data),(this.tambonOptions.splice(0,0,{'tambon_id':'getall','tambon_name':this.$i18n.t('selectAll')}))})
				}else{
					this.isDisabledTambon = 1;
					this.tambon_select = null;
				}
			}
		}
	}
</script>

